// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e3994b59","455":"4afeea18","977":"4ada24ce"}[chunkId] + ".chunk.js";
};